import { WIZ_BOOLEAN, WizBooleanUtils } from '@wizeoo/akm-core-lib';
import { ICellRendererFunc } from 'ag-grid-community';

export class WizAgGridUtils {
  public static CELL_EDITABLE_RENDERER: ICellRendererFunc = ({ valueFormatted }) =>
    `<div class="cell-edit-lbl">${valueFormatted}</div> <i class="wiz-icon- cell-edit-icon">edit</i>`;

  public static CELL_CHECKBOX_RENDERER: ICellRendererFunc = (params) => {
    
    // console.log('CELL_CHECKBOX_RENDERER', params);
    
    switch (WizBooleanUtils.stringToBoolean(params.valueFormatted)) {
      case WIZ_BOOLEAN.TRUE:
        return `<i class="fa-regular fa-square-check wiz-cell-bool"></i>`;
      case WIZ_BOOLEAN.FALSE:
        return `<i class="fa-regular fa-square wiz-cell-bool"></i>`;
      default:
        return `<i class="fa-regular fa-square-minus wiz-cell-bool"></i>`;
    }
  };
}
